import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function registerDataReducer(
  state = initialState.userRegister,
  action
) {
  if (action.type === types.LOAD_REGISTER_DATA_SUCCESS) {
    return action.userRegister;
  }
  return state;
}
